import React, { memo } from 'react';

import { bytesToSize } from 'utils/number';

import Badge from 'components/Badge';
import messages, { definedTypes } from '../Messages';
import { FileTypes } from 'store/survey/surveyTypes';

interface IComponentProps {
  maxSize: number;
  validFormats: FileTypes[] | undefined;
}

const FileFieldsViewer: React.FC<IComponentProps> = ({
  maxSize,
  validFormats,
}) => {
  return (
    <div>
      {messages.validFormats}
      {validFormats &&
        validFormats.map((item: string) => {
          return (
            <Badge color="blue" key={item}>
              {definedTypes[item]}
            </Badge>
          );
        })}
      {messages.maxSizeOfUpload}: {maxSize && bytesToSize(maxSize * 1024)}
    </div>
  );
};

export default memo(FileFieldsViewer);
